import React, {useEffect, useState} from "react";
import "./LocationContent.module.scss";
import styles from "./LocationContent.module.scss";
import {checkDateBeforeNow} from "./location.util";
import {useTranslation} from "react-i18next";

const PopupZones = (props: any) => {
  const { onClose, zoneList, onSelect, isPopupInfoOpen } = props;
  const { t } = useTranslation();
  let [activeMenu, setActiveMenu] = useState(null);
  let [isHalfPopup, setIsHalfPopup] = useState(false);
  console.log("props",props);

  const handleClickBtn = (menu: any) => {
    console.log("menu==>",menu)
    if (activeMenu !== menu?.id) {
      setActiveMenu(menu?.id);
    }
    
    onSelect(menu);
    
  };

  function handleClickHeader() {
    setIsHalfPopup(!isHalfPopup);
  }

  function renderBtnItem(menu: any) {
    if (!menu?.publishedAt) {
      return;
    }
    let isExpired = checkDateBeforeNow(menu?.expiredAt);
    let isPublished = checkDateBeforeNow(menu?.publishedAt);
    if (isExpired || !isPublished) {
      return;
    }
    return (
      <div className={styles.btnItem} onClick={() => {handleClickBtn(menu)}}>
        <div className={activeMenu === menu?.id? styles.iconActive : styles.icon}>
          <img src={menu?.iconImageURL} />
        </div>
        <div className={styles.name}>{menu?.name.replace("_"," ")}</div>
      </div>
    );
  }

  useEffect(() => {
    if (isPopupInfoOpen) {
      setIsHalfPopup(true);
    }
  }, [isPopupInfoOpen]);
  return (
    <div className={styles.zonePopup}>
      <div className={styles.zoneHeader} onClick={() => {handleClickHeader()}}>
        <div className={styles.text}>{t("Zones")}</div>
        <div className={styles.zoneCloseBtn} onClick={onClose}>
          <svg width="12.999" height="12.999">
            <path
              fill="#fff"
              d="M6.5 7.218l5.632 5.632a.508.508 0 1 0 .718-.718L7.218 6.5 12.851.867a.508.508 0 1 0-.719-.719L6.5 5.781.867.148a.508.508 0 0 0-.718.718L5.781 6.5.148 12.133a.508.508 0 1 0 .718.718z"
            />
          </svg>
        </div>
      </div>
      <div
        className={styles.zoneBtnWrapper}
        style={isPopupInfoOpen && isHalfPopup ? { display: "none" } : {}}
      >
        {zoneList?.map((item: any) => {
          return renderBtnItem(item);
        })}
      </div>
    </div>
  );
};

export default PopupZones;